module.exports = __webpack_public_path__ + "static/media/so-stock--sheep4.2d7c60bb.jpg";